module.exports = __webpack_public_path__ + "static/media/antibodies.1422a402.svg";